
import { Component, EventEmitter, Input, OnInit, SimpleChanges, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';

@Component({
    selector: 'app-rent-search',
    templateUrl: './rent-search.component.html',
    styleUrls: ['./rent-search.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class RentSearchComponent {

  businessLine: CarBusinessLine = CarBusinessLine.RENT; 

}